import { z } from "zod"
import { PoapCode } from "./PoapCode"
import { PoapCodeSchema, type PoapCodeType } from "@tutellus/schemas"

export const PoapCodeListValidation = z.object({
  items: z.array(z.instanceof(PoapCode)),
})

export class PoapCodeList {
  constructor(private readonly _items: PoapCode[]) {}

  static create({ items }: z.infer<typeof PoapCodeListValidation>) {
    const { error, success } = PoapCodeListValidation.safeParse({ items })
    if (!success) throw new Error(error.message)
    return new PoapCodeList(items)
  }

  static createFromAPI(data: PoapCodeType[]) {
    const { error, success } = z.array(PoapCodeSchema).safeParse(data)
    if (!success) throw new Error(`Invalid PoapCodeList data: ${error.message}`)

    const items = data.map((item) => PoapCode.createFromAPI(item))
    return PoapCodeList.create({ items })
  }

  get items() { return this._items } // prettier-ignore

  serialize() {
    return {
      items: this._items.map((code) => code.serialize()),
    }
  }
}

export type PoapCodeListSerialized = ReturnType<PoapCodeList["serialize"]>
